import { PROFILE_KEYS } from '../../../i18n/constants/keys';
import { PROFILE_SECTION_IDS } from '../constants';
import type { IProfileSection } from '../interfaces';

export const getProfileSections = (userRole: string): IProfileSection[] => {
  const sections: IProfileSection[] = [
    {
      id: PROFILE_SECTION_IDS.PERSONAL,
      titleKey: PROFILE_KEYS.sections.personal.title,
      descriptionKey: PROFILE_KEYS.sections.personal.description,
    },
    {
      id: PROFILE_SECTION_IDS.ACCOUNT,
      titleKey: PROFILE_KEYS.sections.account.title,
      descriptionKey: PROFILE_KEYS.sections.account.description,
    },
    {
      id: PROFILE_SECTION_IDS.NOTIFICATIONS,
      titleKey: PROFILE_KEYS.sections.notifications.title,
      descriptionKey: PROFILE_KEYS.sections.notifications.description,
    },
    {
      id: PROFILE_SECTION_IDS.PRIVACY,
      titleKey: PROFILE_KEYS.sections.privacy.title,
      descriptionKey: PROFILE_KEYS.sections.privacy.description,
    },
  ];

  if (userRole === 'Candidate') {
    sections.push({
      id: PROFILE_SECTION_IDS.CANDIDATE,
      titleKey: PROFILE_KEYS.sections.candidate.title,
      descriptionKey: PROFILE_KEYS.sections.candidate.description,
    });
  }

  return sections;
};
